import strings from '../../lang/strings.json';

export default {
  maxPages: 1,
  init() {
    const browseGrid = document.querySelector('.ms-browse-grid');

    if (!browseGrid) { return; }

    this.currentLang = document.querySelector('html').lang;
    this.currentPage = 1;
    this.startBrowseGrid();
    this.prevNextHandler();
  },
  startBrowseGrid() {
    const browseGrid = document.querySelector('.ms-browse-grid');
    const categoryHeros = document.querySelectorAll('.ms-category-hero');
    const collectionTiles = categoryHeros[1];
    const filterType = browseGrid.dataset.filterType;

    // evaluate the display of any existing collection tiles
    if (filterType === 'collection' && collectionTiles) {
      collectionTiles.style.display = 'block';
    }
  },
  prevNextHandler() {
    const _this = this;
    const pagination = document.querySelector('nav.pagination');
    const prevLink = pagination.querySelector('.page-numbers.prev');
    const nextLink = pagination.querySelector('.page-numbers.next');

    const prevHandler = (e) => {
      e.preventDefault();
      if (_this.currentPage === 1) { return; }
      const keyed = !e.clientX && !e.clientY;
      _this.currentPage === 1 ? _this.currentPage = 1 : _this.currentPage--;
      _this.ajaxHandler(_this.currentPage, keyed);
    }
    prevLink.removeEventListener('click', prevHandler);
    prevLink.addEventListener('click', prevHandler);

    const nextHandler = (e) => {
      e.preventDefault();
      if (_this.currentPage >= _this.maxPages) { return; }
      const keyed = !e.clientX && !e.clientY;
      _this.currentPage >= _this.maxPages ? _this.currentPage = _this.maxPages : _this.currentPage++;
      _this.ajaxHandler(_this.currentPage, keyed);
    }
    nextLink.removeEventListener('click', nextHandler);
    nextLink.addEventListener('click', nextHandler);
  },

  startAjaxPagination() {
    const pagination = document.querySelector('nav.pagination');
    const _this = this;

    if (!pagination) { return; }

    const pageLinks = pagination.querySelectorAll('.page-numbers:not(.next):not(.prev):not(.dots)');
    const numberedPaginationHandler = (e) => {
      e.preventDefault();

      if (parseInt(e.target.textContent) === _this.currentPage) { return; }

      const keyed = !e.clientX && !e.clientY;
      _this.currentPage = parseInt(e.target.textContent);
      _this.ajaxHandler(_this.currentPage, keyed);
    }

    pageLinks.forEach((el) => {
      let pageNumber = parseInt(el.textContent);
      el.setAttribute('aria-label', `${strings[_this.currentLang].page} ${pageNumber}${pageNumber === _this.currentPage ? `, ${strings[_this.currentLang].currentPage}` : ''}`);
      el.removeEventListener('click', numberedPaginationHandler);
      el.addEventListener('click', numberedPaginationHandler);
    });

    // launch on load
    this.handlePrevNextStyling();
  },
  handlePrevNextStyling () {
    const pagination = document.querySelector('nav.pagination');

    if (!pagination) { return; }

    const prevLink = pagination.querySelector('.page-numbers.prev');
    const nextLink = pagination.querySelector('.page-numbers.next');

    if (this.currentPage === 1) {
      prevLink.style.display = 'none';
    }

    if (this.currentPage === this.maxPages) {
      nextLink.style.display = 'none';
    }

    // in between
    if (this.currentPage > 1) {
      prevLink.style.display = 'inline';
    }

    // in between
    if (this.currentPage !== this.maxPages) {
      nextLink.style.display = 'inline';
    }
  },
  redrawPageLinks() {
    const pagination = document.querySelector('nav.pagination');

    if (!pagination) { return; }

    const pageLinks = pagination.querySelectorAll('.page-numbers:not(.next):not(.prev):not(.dots)');
    let firstPageNumber = (this.currentPage - 1 > 0) ? this.currentPage - 1 : this.currentPage;
    let lastPageNumber = (firstPageNumber + 2) < this.maxPages ? firstPageNumber + 2 : this.maxPages;

    // reset everything first
    pageLinks.forEach(el => {
      let pageNumber = parseInt(el.textContent);

      if( lastPageNumber === this.maxPages ) {
        firstPageNumber = lastPageNumber - 2;
      }

      if( pageNumber >= firstPageNumber && pageNumber <= lastPageNumber ) {
        el.style.display = 'inline-block';
      } else {
        el.style.display = 'none';
      }
    });
  },
  ajaxHandler(page, keyed) {
    const browseGrid = document.querySelector('.ms-browse-grid');
    const targetContainer = browseGrid.querySelector('.ms-browse-grid__cards-wrapper');
    const filterType = browseGrid.dataset.filterType;
    const filterIds = browseGrid.dataset.tagIds.split(',').map(Number); // split then convert to integer
    const targetPage = browseGrid.dataset.targetPage;
    const navPagination = browseGrid.querySelector('nav.pagination');
    const ajaxPagination = browseGrid.querySelector('.ms-browse-grid__pagination');
    const _this = this;

    fetch(window.msAjax.ajax_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
      body: `action=fetch_browse_grid_data&page=${page}&filter_type=${filterType}&target_page=${targetPage}&filter_ids=${filterIds}`})
      .then(resp => resp.json())
      .then(({ html, displayed_items, pagination, max_num_pages }) => {
        _this.maxPages = max_num_pages;
        targetContainer.innerHTML = '';
        targetContainer.innerHTML = html;
        navPagination.style.display = 'none';

        if ( pagination ) {
          ajaxPagination.innerHTML = pagination;
          navPagination.style.removeProperty('display');
        }

        // Scroll to Browse Grid module
        const scrollToBrowseGrid = () => {
          const $header = document.querySelector('.ms-navigation');
          const yOffset = keyed ? 0 : $header.getBoundingClientRect().height;
          const y = targetContainer.getBoundingClientRect().top + window.pageYOffset - yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        };
        scrollToBrowseGrid();

        // SR only. Announce the current page and number of items displayed.
        const a11yLive = document.createElement('span');

        a11yLive.setAttribute('aria-live', 'polite');
        a11yLive.classList.add('ms-browse-grid__results-announcement');
        a11yLive.innerHTML = `${strings[this.currentLang].currentPage}, ${page}. ${strings[this.currentLang].displaying} ${displayed_items} ${displayed_items > 1 ? strings[this.currentLang].items : strings[this.currentLang].item}`;

        // Append to the main module.
        browseGrid.appendChild(a11yLive);

        // Remove it after announcing, estimated 2 seconds.
        setTimeout(() => {
          a11yLive.remove();
        }, 2000);
        _this.startAjaxPagination();
        _this.redrawPageLinks();
      })
      .finally(() => {
        // Set the focus back to the card list after changing page for proper focus order.
        // Set timeout around 2 seconds.
        targetContainer.setAttribute('tabindex', -1);

        setTimeout(() => {
          // Focus when keyed
          keyed && targetContainer.focus();
          targetContainer.removeAttribute('tabindex');
        }, 2000);
      });
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/browse-grid.js